import React from 'react';
import {
    PREVIEW_LOCK_NOTE_ID,
    PREVIEW_LOCK_REASON,
} from '@/shared/hooks/usePreviewLock';

export default function PreviewLockNote({ locked }) {
    if (!locked) return null;
    return (
        <p id={PREVIEW_LOCK_NOTE_ID} className="small text-body-secondary mb-0">
            {PREVIEW_LOCK_REASON}
        </p>
    );
}
